import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapLocationPageComponent from './mapLocationPage.component';

let mapLocationPageModule = angular.module('mapLocationPage', [
  uiRouter
])

.component('mapLocationPage', mapLocationPageComponent)

.name;

export default mapLocationPageModule;
